import {
  Component,
  Directive,
  HostListener,
  Optional,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

import { DialogRef, Dialog } from "../../../dialog.base";

@Component({
  selector: "uex-dialog-dismiss",
  templateUrl: "./dismiss.component.html"
})
export class DialogDismissComponent {
  @Input() public autodismiss: boolean = true;
  @Output() public color: string = "dark";
  @Output("click") private _onClick: EventEmitter<void> = new EventEmitter();

  constructor(@Optional() private _dialogRef: DialogRef) {
    this._dialog = this._dialogRef.dialog;
  }

  private _dialog: Dialog;

  /**
   * @internal
   */
  public onClick(event: MouseEvent) {
    if (this._dialog && this.autodismiss) this._dialog.dismiss();
    this._onClick.emit();
  }
}

@Directive({
  selector: "[dialogDismiss], [dialog-dismiss]"
})
export class DialogDismissDirective {
  constructor(@Optional() private _dialogRef: DialogRef) {
    this._dialog = this._dialogRef.dialog;
  }

  private _dialog: Dialog;

  @HostListener("click") public _onClick() {
    if (this._dialog) this._dialog.dismiss();
  }
}
